import styled from "styled-components";
import { FaSwimmingPool } from "react-icons/fa";
import { MdFreeBreakfast } from "react-icons/md";
import { FaWifi } from "react-icons/fa";
import { BiSolidFridge } from "react-icons/bi";
import { MdRoomService } from "react-icons/md";
import { FaBabyCarriage } from "react-icons/fa";
import { MdOutlinePets } from "react-icons/md";
import struttura from '../images/struttura.jpg';
import { useMediaQuery } from "react-responsive";
import { useTranslation } from "react-i18next";
import { TbAirConditioning } from "react-icons/tb";

const LittleHero = () => {
    const {t} = useTranslation();
    const isMobile = useMediaQuery({ query: '(max-width: 668px)' });
  return (
    <Wrapper>
        <div className="container">
            <div className="row">
                <div className="col-12 col-md-6" style={isMobile ? {padding: '5px'} : {padding: '15px'}}>
                    <img src={struttura} alt="" />
                </div>
                <div className="col-12 col-md-6" style={isMobile ? {padding: '5px'} : {padding: '15px'}}>
                    <div className="inside">
                        <h1>{t('camere2')}</h1>
                        <p>{t('camereSottotitolo')}</p>
                        <ul className="list">
                            <li>
                                <MdFreeBreakfast className="icon" />
                                <div>{t('colazione')}</div>
                            </li>
                            <li>
                                <FaWifi className="icon" />
                                <div>Wifi</div>
                            </li>
                            <li>
                                <FaSwimmingPool className="icon" />
                                <div>{t('piscina')}</div>
                            </li>
                            <li>
                                <BiSolidFridge className="icon" />
                                <div>{t('frigoBar')}</div>
                            </li>
                            <li>
                                <MdRoomService className="icon" />
                                <div>{t('servizioBar')}</div>
                            </li>
                            <li>
                                <TbAirConditioning className="icon" />
                                <div>{t('condizionatore')}</div>
                            </li>
                            <li>
                                <FaBabyCarriage className="icon" />
                                <div>{t('culla')}</div>
                            </li>
                            <li>
                                <MdOutlinePets className="icon" />
                                <div>{t('animaliAmmessi')}</div>
                            </li>
                        </ul>  
                    </div>
                </div>
            </div>
        </div>
    </Wrapper>
  )
}

export default LittleHero;


const Wrapper = styled.div`
    /* background-color: var(--gray); */
    .container {
        height: 100%;
        .row {
            height: 100%;
            justify-content: center;
            align-items: flex-start;
            .col-12 {
                img {
                    width: 100%;
                    object-fit: cover;
                    object-position: center;
                    border-radius: 10px;
                }
                .inside {
                    padding: 15px;
                    background-color: var(--gray);
                    border-radius: 10px;
                    h1 {
                        font-size: 25px;
                        display: inline-block;
                        padding-right: 5px;
                        text-transform: uppercase;
                        color: var(--logo);
                        border-bottom: 2px solid var(--logo);
                    } 
                    p {
                        font-weight: bold;
                        margin: 10px 0px 15px 0px;
                        font-size: 20px;
                    }
                    .list {                    
                        list-style: none;
                        li {
                            &:not(:last-child) {
                                margin-bottom: 15px;
                            }
                            display: flex;
                            justify-content: flex-start;
                            align-items: center;
                            .icon {
                                color: var(--logo);
                                width: 25px;
                                height: 25px;
                                margin-right: 15px;
                                display: block;
                            }
                            div {
                                font-size: 18px;
                            }
                        }
                    }
                }
            }
        }
    }
`